import { EnvRule } from './env-validate.config'

export class ConfigRepository<T extends Record<string, EnvRule>> {
  private readonly _env = (process.env || {}) as Record<string, string | undefined>
  private readonly _schema: T

  constructor (schema: T) {
    this._schema = schema
  }

  /** Возвращает список проблем; пустой массив — конфиг валиден. */
  public validate (): string[] {
    const errors: string[] = []

    for (const [ key, rule ] of Object.entries(this._schema)) {
      const value = this._env[key]

      if (rule.required && !value) {
        errors.push(`${ key } is required`)
        continue
      }

      if (value && rule.uri) {
        try {
          new URL(value)
        } catch {
          errors.push(`${ key } must be a valid URI`)
        }
      }
    }

    return errors
  }

  public get<K extends keyof T> (key: K, _default = ''): string {
    return this._env[key as string] || _default
  }

  public number (key: keyof T, _default?: number): number {
    const value = this._env[key as string]
    return value !== undefined ? Number(value) : _default!
  }

  public boolean (key: keyof T, _default = false): boolean {
    const value = this._env[key as string]
    return value === undefined ? _default : value === 'true'
  }

  public array (key: keyof T, separator = ',', _default: string[] = []): string[] {
    const value = this._env[key as string]

    if (!value) return _default

    return value
      .split(separator)
      .map((item) => item.trim())
      .filter(Boolean)
  }
}
